/* eslint-disable @typescript-eslint/no-unused-vars */
import { createApi } from '@reduxjs/toolkit/query/react';
import {
CambiarContrasenaRequest, CambiarContrasenaResponse, RecuperarContrasenaRequest, RecuperarContrasenaResponse, UsuarioDisponibleResponse,
reducirAccesosToRoles, type IestadoUsuario, type LoginRequest, type LoginResponse
} from 'src/redux/api/types/auth';
import { setUsuario } from 'src/redux/features/usuarioSlice';
import baseQuery from 'src/redux/api/baseQuery';
import { ItemMenu, obtenerOpcionesSegunRol, obtenerPrimerItemConRuta, buscarMenuLateral } from 'src/utils/menu/menus';
import { Irol, obtenerDescripcionRol } from 'src/utils/roles/roles';
import { Dispatch } from '@reduxjs/toolkit';
import jwt_decode from 'jwt-decode';

/**
* Función auxiliar para manejar la lógica de almacenamiento y configuración del usuario
*/
const handleUserSetup = async (data: LoginResponse, dispatch: Dispatch) => {
localStorage.setItem('token', data.token);
const decodedToken: any = jwt_decode(data.token)
// const rolActivoString = await localStorage.getItem('rolActivo');
 const rutaActivaString = await localStorage.getItem('ruta');
// if (rolActivoString) {
//     rolActivo = JSON.parse(rolActivoString) as Irol;
// } else {
//     rolActivo = reducirAccesosToRoles(data.usuario.accesos).length > 0 ? reducirAccesosToRoles(data.usuario.accesos)[0] : undefined;
// }
const menu: ItemMenu[] = obtenerOpcionesSegunRol(decodedToken.roles, []);;
// if (rolActivo) {
//     menu = obtenerOpcionesSegunRol(rolActivo.id, [{ key: 'idUnidadAcademica', valor: data.unidadAutenticado }]);
// }
const usuario: IestadoUsuario = {
    token: data.token,
    usuario: { ...data.usuarioResponse },
    menu,
    menuLateral: menu.length > 0 ? buscarMenuLateral(menu, rutaActivaString) : undefined,
    rolActivo: obtenerDescripcionRol(decodedToken.roles as string) ,
};
dispatch(setUsuario(usuario));
};

/**
* API para autenticación de usuarios
* @see https://redux-toolkit.js.org/rtk-query/overview
* @see https://redux-toolkit.js.org/rtk-query/usage/customizing-queries
*/
export const authApi = createApi({
reducerPath: 'authApi',
baseQuery,
endpoints: (builder) => ({
    usuariosDisponibles: builder.query<UsuarioDisponibleResponse[], string>({
        query(usuario) {
            return {
                url: 'v1/autenticacion/usuarios-unidades',
                method: 'GET',
                credentials: 'include',
                params: { correoOrIdentificacion: usuario.toLowerCase().trim() },
            };
        },
    }),
    login: builder.mutation<LoginResponse, LoginRequest>({
        query(body) {
            return {
                url: 'usuarios/inicio-sesion',
                method: 'POST',
                credentials: 'include',
                body: {
                    identificacionCorreo: body.correo,
                    contrasena: body.contrasena
                },
            };
        },
        async onQueryStarted(_args, { dispatch, queryFulfilled }) {
            try {
                const { data } = await queryFulfilled;
                await handleUserSetup(data, dispatch);
            } catch (error) {
                /* empty */
            }
        },
        transformResponse: (response: LoginResponse) => {
            const decodedToken: any = jwt_decode(response.token)    
            const opcionesMenu = obtenerOpcionesSegunRol(decodedToken.roles, []);
            const menuLateral = opcionesMenu.length > 0 ? opcionesMenu[0].menuLateral : [];
            const redireccion = obtenerPrimerItemConRuta(menuLateral);
            const breadcrumbs = [
                { label: redireccion?.label || '', url: redireccion?.path || '/' },
            ];
            return { ...response, redirectTo: redireccion?.path, breadcrumbs };
        }, 
    }),
    refreshToken: builder.mutation<LoginResponse, void>({
        query() {
            return {
                url: 'usuarios/refresh-token',
                method: 'POST',
                credentials: 'include',
            };
        },
        async onQueryStarted(_args, { dispatch, queryFulfilled }) {
            try {
                const { data } = await queryFulfilled;
                await handleUserSetup(data, dispatch);
            } catch (error) {
                /* empty */
            }
        },
    }),
    recuperarContrasena: builder.mutation<RecuperarContrasenaResponse, RecuperarContrasenaRequest>({
        query({ usuariounidadId }) {
            return {
                url: `v1/autenticacion/recuperar-contrasena/${usuariounidadId}`,
                method: 'POST',
                credentials: 'include',
            };
        },
    }),
    cambiarContrasena: builder.mutation<CambiarContrasenaResponse, CambiarContrasenaRequest>({
        query({ contrasena, token }) {
            return {
                url: 'v1/autenticacion/cambiar-contrasena',
                method: 'POST',
                credentials: 'include',
                body: { contrasena },
                headers: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    Authorization: `Bearer ${token}`,
                },
            };
        },
    }),
}),
});

export const {
useLoginMutation, useRefreshTokenMutation, useLazyUsuariosDisponiblesQuery, useCambiarContrasenaMutation, useRecuperarContrasenaMutation
} = authApi;